<h2 mat-dialog-title>Choose a Dress</h2>
<mat-dialog-content class="mat-typography">
  <div class="main">
    <h3>As per Terms and Conditions you can only rent one dress at a time</h3>
    <div *ngFor="let cloth of data.dressData">
        <input *ngIf="cloth.status == '1'" id="enum_answer_{{cloth._id}}" type="radio" [value]="cloth" name="selected" [(ngModel)]="radioSelected">
        <span *ngIf="cloth.status == '1'">{{cloth.dress_name}}</span>
    </div>
    <div *ngFor="let cloth of data.dressData">
      <input *ngIf="cloth.status == '2'" disabled id="enum_answer_{{cloth._id}}" type="radio" [value]="cloth" name="selected" [(ngModel)]="radioSelected">
      <span *ngIf="cloth.status == '2'">{{cloth.dress_name}}</span>
    </div>
  </div>




</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="checkout" (click)="checkOut()">CheckOut</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>